export default __webpack_public_path__ + "static/media/icon-GMX_sm.195e3c0f.svg";